/**
 * Initializes the mobile navigation behavior.
 * Adds a scroll event listener to toggle the 'navigation-scroll' class on the page header
 * when the user scrolls, but only if the device is mobile and the body has the data-navigation attribute set to "b".
 */
export const initNavigationMobile = () => {
  const isMobile = window.innerWidth <= 768;

  if ( isMobile ) {
    window.addEventListener('scroll', function() {
      const scrollPosition = window.scrollY || document.documentElement.scrollTop || document.body.scrollTop;
      const pageHeader = document.querySelector('.section-header page-header');
      if ( pageHeader ) {
        scrollPosition > 0 ? pageHeader.classList.add('navigation-scroll') : pageHeader.classList.remove('navigation-scroll');
      }
    });
  }
}